import { Stack, Button, Typography } from "@mui/material";

export interface PaginationBarProps {
  /** Total count from API */
  count: number;
  /** Current 1-based page */
  page: number;
  onPrev: () => void;
  onNext: () => void;
  /** Disable prev/next while loading */
  disabled?: boolean;
  /** Has previous page */
  hasPrev: boolean;
  /** Has next page */
  hasNext: boolean;
}

export default function PaginationBar({
  count,
  page,
  onPrev,
  onNext,
  disabled = false,
  hasPrev,
  hasNext,
}: PaginationBarProps) {
  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      spacing={2}
      alignItems="center"
      justifyContent="space-between"
      sx={{ mt: 2 }}
    >
      <Typography variant="body2" color="text.secondary">
        Total: {count} · Page {page}
      </Typography>
      <Stack direction="row" spacing={1}>
        <Button onClick={onPrev} disabled={disabled || !hasPrev} size="small">
          Previous
        </Button>
        <Button onClick={onNext} disabled={disabled || !hasNext} size="small">
          Next
        </Button>
      </Stack>
    </Stack>
  );
}
